import { WhichAxis } from "../../../../CoStar/Api/Analytics/ViewModels/Charting/index.js";
/** CoStar.Api.PropertyUser.Charting.WhichAxis */
export { WhichAxis };
